



















import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class RegisterStep extends Vue {
  @Prop({default: 1})
  count: number;

  @Prop({default: 1})
  step: number;
}
